(() => {
  if (window.O7CommunityDirectory) return;
  window.O7CommunityDirectory = true;

  const setup = (root) => {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    const cards = [...root.querySelectorAll("[data-partner]")];
    const placeButtons = [...root.querySelectorAll("[data-filter-place]")];
    const typeButtons = [...root.querySelectorAll("[data-filter-type]")];
    const more = root.querySelector("[data-show-more]");
    const empty = root.querySelector("[data-empty]");
    const initial = Number.parseInt(root.dataset.initial || "4", 10);
    let place = "all";
    let type = "all";
    let expanded = false;

    const setActive = (buttons, value, attr) => {
      buttons.forEach((button) => {
        const on = button.getAttribute(attr) === value;
        button.classList.toggle("is-active", on);
        button.setAttribute("aria-pressed", on ? "true" : "false");
      });
    };

    const apply = () => {
      let matches = 0;
      let visible = 0;
      cards.forEach((card) => {
        const placeOk = place === "all" || card.dataset.place === place;
        const typeOk = type === "all" || card.dataset.type === type;
        if (!placeOk || !typeOk) {
          card.hidden = true;
          return;
        }
        matches += 1;
        const hide = !expanded && visible >= initial;
        card.hidden = hide;
        if (!hide) visible += 1;
      });
      if (empty) empty.hidden = matches !== 0;
      if (more) {
        more.hidden = matches <= initial;
        more.textContent = expanded ? more.dataset.less : more.dataset.more;
      }
    };

    placeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        place = button.dataset.filterPlace;
        expanded = false;
        setActive(placeButtons, place, "data-filter-place");
        apply();
      });
    });

    typeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        type = button.dataset.filterType;
        expanded = false;
        setActive(typeButtons, type, "data-filter-type");
        apply();
      });
    });

    if (more) {
      more.addEventListener("click", () => {
        expanded = !expanded;
        apply();
      });
    }

    apply();
  };

  document.querySelectorAll("[data-o7-directory]").forEach(setup);
  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector("[data-o7-directory]");
    if (root) setup(root);
  });
})();
